
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AdminSidebar } from "@/components/AdminSidebar";
import { TopNavigation } from "@/components/TopNavigation";
import OverviewDashboard from "@/components/OverviewDashboard";
import ProductManagement from "@/components/ProductManagement/ProductManagement";
import CategoryManagement from "@/components/CategoryManagement/CategoryManagement";
import { OrderManagement } from "@/components/OrderManagement";
import ArtistApplicationsManagement from "@/components/ArtistApplications";
import ArtistDetailsManagement from "@/components/ArtistDetails";
import { RankingManagement } from "@/components/RankingManagement";
import NotFound from "./NotFound";
import ProtectedRoute from "@/components/ProtectedRoute";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import AutoLogoutHandler from "@/components/AutoLogoutHandler";

const queryClient = new QueryClient();

const App = () => {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <AutoLogoutHandler />
          <BrowserRouter>
            <ProtectedRoute>
              <SidebarProvider defaultOpen={false}>
                <div className="min-h-screen flex w-full bg-gray-50 font-inter">
                  <AdminSidebar />
                  <div className="flex-1 flex flex-col min-w-0">
                    <TopNavigation />
                    <main className="flex-1 overflow-auto">
                      <Routes>
                        <Route path="/" element={<OverviewDashboard />} />
                        <Route path="/products" element={<ProductManagement />} />
                        <Route path="/categories" element={<CategoryManagement />} />
                        <Route path="/orders" element={<OrderManagement />} />
                        <Route path="/artist-applications" element={<ArtistApplicationsManagement />} />
                        <Route path="/artist-details" element={<ArtistDetailsManagement />} />
                        <Route path="/ranking" element={<RankingManagement />} />
                        <Route path="*" element={<NotFound />} />
                      </Routes>
                    </main>
                  </div>
                </div>
              </SidebarProvider>
            </ProtectedRoute>
          </BrowserRouter>
        </TooltipProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
};

export default App;
